<!-- [ai-refactored-code] -->
<h1 mat-dialog-title class="text-dark text-xl">Dettaglio record CEM</h1>
<div mat-dialog-content class="w-full">
  <app-garage-passage-detail-form
    [data]="data"
    (modalClose)="modalClose.emit($event)"
  ></app-garage-passage-detail-form>
</div>
